import { render, staticRenderFns } from "./AccountsClassificationEdit.vue?vue&type=template&id=c090a4f2&scoped=true&"
import script from "./AccountsClassificationEdit.vue?vue&type=script&lang=js&"
export * from "./AccountsClassificationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c090a4f2",
  null
  
)

export default component.exports